import {APIClient} from '../backend/ApiClient';
import {StorageObject} from '../models/StorageObject';

export const useGetStorageObject = () => {
    const apiClient = APIClient();

    return (path: string): Promise<StorageObject> => {
        return apiClient.getStorageObject(path);
    };
};
